import React, { } from 'react'
import { Statistic } from 'antd'
import { SummaryContent } from '../dashboard.styled'
import ChartHeader from './ChartHeader'

function Summary (props) {
  const { data, settingMode } = props
  const { UISetting, content = {} } = data || {}
  const { prefix, suffix, decimal } = UISetting

  return (
    <>
      <ChartHeader {...props} />
      <SummaryContent>
        <Statistic value={settingMode ? '1000' : content?.data?.[0]?.value} prefix={prefix} suffix={suffix} precision={decimal} />
      </SummaryContent>
    </>
  )
}

export default Summary
